<template>
  <li>
    <button
      v-if="title"
      type="button"
      aria-expanded="false"
      aria-haspopup="true"
      :class="{
        'flex h-full flex-nowrap items-baseline': true,
      }"
      @click.stop="toggleActive(activeMenu)"
    >
      <span
        :class="{
          'whitespace-nowrap text-13px font-bold uppercase text-www-color-white md:text-10px md:font-medium lg:text-13px 2xl:text-18px': true,
          'transition-all duration-300': true,
          'flex items-center gap-1 md:inline-block': true,
          'border-www-color-white after:block after:h-2 after:w-2 after:-rotate-[135deg] after:border-b-2 after:border-l-2 after:content-[\'\'] md:after:hidden': true,
        }"
        >{{ title }}
      </span>
      <div
        aria-hidden="true"
        :class="{
          'relative ml-10px hidden h-[7px] w-3 cursor-pointer md:inline-block lg:-top-[0.0938rem]': true,
        }"
      >
        <div
          :class="{
            'rotate-icon ease-[bezier(0.66, 0.66, 0.34, 1.00)] border-white bg-white inline-block h-6px w-[0.0938rem] -translate-x-[3px] rounded border-b-8 text-www-color-white transition-all duration-[350ms] motion-reduce:transition-none': true,
            [getRotationClass(activeMenu)]: true,
          }"
        ></div>
        <div
          :class="{
            'rotate-icon ease-[bezier(0.66, 0.66, 0.34, 1.00)] border-white bg-white inline-block h-6px w-[0.0938rem] rounded border-b-8 text-www-color-white transition-all duration-[350ms] motion-reduce:transition-none': true,
            [getMinusRotationClass(activeMenu)]: true,
          }"
        ></div>
      </div>
    </button>
    <Transition name="slide">
      <EducationMegaMenu
        v-show="model == activeMenu"
        v-bind="props"
      />
    </Transition>
  </li>
</template>

<script lang="ts" setup>
import type { EducationDropdown } from '~/sanity/types';
import EducationMegaMenu from '~/components/Organisms/EducationHeader/EduMegaMenu.vue';

interface Props extends EducationDropdown {
  activeMenu: string;
}
const props = defineProps<Props>();
const model = defineModel<string | null>({ default: null });
async function toggleActive(itemTitle: string) {
  if (model.value === itemTitle) {
    model.value = null;
  } else {
    model.value = itemTitle;
  }
}

const getMinusRotationClass = (title: string) => {
  return model.value === title ? '-rotate-[45deg]' : '-rotate-[135deg]';
};

const getRotationClass = (title: string) => {
  return model.value === title ? 'rotate-[45deg]' : 'rotate-[135deg]';
};
</script>

<style>
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}
</style>
